/* eslint-disable no-param-reassign */

document.addEventListener('DOMContentLoaded', () => {
    const statisticsNumbers = document.querySelectorAll('.block-statistics .countup');

    statisticsNumbers.forEach((element) => {
        const rawText = element.innerText.replace(/\s/g, '');
        const parsedNumber = parseFloat(rawText);

        if (!Number.isNaN(parsedNumber)) {
            const formattedNumber = parsedNumber.toLocaleString('fr-CA');
            element.innerText = formattedNumber;
        }
    });
});
